//import tool from '../../_lib/js/tool.js'
const store = {
	state: {
		bgm: null,
		bgmindex: 0,
		token: '',
		bgmIsPlay: window.config.bgmIsPlay || false,
		maxWidth: 0,
		maxHeight: 0,
		currentPage: '',
		appShow: false,
		app: null,
		yinxiao: {},
		swiper: null,
		man: 1,
		shareInfo:{
			storeCode:'',
			id:'',
		},
		tool: {
			time: 0,
			order: 0,
			notice: 0
		},
		userInfo: {
			unionid: '',
			headimgurl: '',
			nickname: '',
		},
		noticeShow: true
	},
	mutations: {
		init(state, payload) {
			state.appShow = true
			state.app = payload.app
		},
		bgmPause(state) {
			state.bgmIsPlay = false
		},
		bgmPlay(state) {
			state.bgmIsPlay = true
		},
		setMaxSize(state, payload) {
			state.maxWidth = payload.width
			state.maxHeight = payload.height
		},
		setCurrentPage(state, payload) {
			state.currentPage = payload.page
		},
		setToken(state, payload) {
			state.token = payload.token
		},
		setYinxiao(state, payload) {
			state.yinxiao[payload.name] = payload.audio

		},
		playYinxiao(state, payload) {

			if (state.bgmIsPlay) {
				let arr = state.yinxiao[payload.name]
				arr[0].audio.play()


				// let num = 0
				// let arr = state.yinxiao[payload.name]
				// console.log(arr)
				// for (let i = 0; i < arr.length; i++) {
				// 	if(i==0){
				// 		num = arr[i].num
				// 	}else{
				// 		num = Math.min(num,arr[i].num)
				// 	}	
				// }
				// for (let i = 0; i < arr.length; i++) {
				// 	if (arr[i].audio.paused && arr[i].num<=num) {
				// 		arr[i].num++
				// 		arr[i].audio.play()
				// 		break
				// 	} else {
				// 		continue
				// 	}
				// }								
			}

		},
		pauseYinxiao(state, payload) {
			state.yinxiao[payload.name].forEach((item) => {
				item.audio.load()
			})
		},
		pauseAllYinxiao(state) {
			for (let i in state.yinxiao) {
				state.yinxiao[i].forEach((item) => {
					item.audio.load()
				})
			}
		},
		setBgm(state, payload) {
			state.bgm = payload.value
		},
		setBgmIndex(state, payload) {
			state.bgm[state.bgmindex].pause()
			state.bgmindex = payload.value
			state.bgm[state.bgmindex].play()
		},
		changeBgm(state, payload) {
			state.bgm.src = payload.src
			state.bgm.load()
			state.bgm.play()
		},
		setSwiper(state, payload) {
			state.swiper = payload.value
		},
		setMan(state, payload) {
			state.man = payload.value
		},
		setTool(state, payload) {
			for (let i in payload) {
				state.tool[i] = state.tool[i] + payload[i]
			}
		},
		setUserInfo(state, payload) {
			state.userInfo = payload
		},
		setNoticeShow(state, payload) {
			state.noticeShow = payload.value
		},
		setShareInfo(state, payload) {
			state.shareInfo = payload
		},
	}
}

export default {
	store: store
}
